import { Component, OnInit } from '@angular/core';
import { ContentService } from 'src/app/_core/_services/content.service';
import { BehaviorService } from 'src/app/_core/_services/behavior.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { EventsService } from 'src/app/_core/_services/events.service';
import { GlobalService } from 'src/app/_core/global.service';

@Component({
  selector: 'app-game-info',
  templateUrl: './game-info.component.html',
  styleUrls: ['./game-info.component.scss']
})
export class GameInfoComponent implements OnInit {

  public relatedCategories$: any = [
    { categoryName: null, categoryId: null, categoryMedia: null },
    { categoryName: null, categoryId: null, categoryMedia: null }
  ]

  public gameSlideConfig: any = {
    centerMode: true,
    centerPadding: '250px',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    autoplay: false,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  }

  private contentCount: number = window.innerWidth >= 768 ? 18 : 9;
  public gameCategoryName: string;
  // public gamesToSlider: any
  public theGame: any;

  public showGameInfo: boolean = false;

  constructor(
    private neo: ContentService,
    private beh: BehaviorService,
    private route: ActivatedRoute,
    private router: Router,
    public _location: Location,
    public events: EventsService,
    public global: GlobalService
  ) {
    this.route.params.subscribe(params => {

      this.neo.loadContentInfo(params.categoryId, params.gameId).subscribe(gameInfo => {
        // this.gamesToSlider = [];
        // this.gamesToSlider.push(gameInfo.result);
        this.theGame = gameInfo.result;

        this.events.eventStart({ eventType: 'GAME_PAGE_ACCESS', eventCategory: 'ACCESS', mediaId: this.theGame.id, catId: this.theGame.catId });

        this.beh._categories.subscribe(cats => {
          if (cats) {
            let randCatIndex = Math.floor(Math.random() * (cats.length - 1));
            for (let cat of cats) { cat.catId == params.categoryId && (this.gameCategoryName = cat.catName) }
            this.relatedCategories$[0].categoryName = 'global.similarGames';
            this.relatedCategories$[0].categoryId = params.categoryId;
            this.relatedCategories$[1].categoryId = cats[randCatIndex].catId;

            this.neo.loadCategoryContent(params.categoryId, 5, 1).subscribe(cont => {
              this.relatedCategories$[0].categoryMedia = cont.result;
              /* for (let item of cont.result) { item.id != params.gameId && this.gamesToSlider.push(item) } */
            });

            this.neo.loadContentsByCategories([cats[randCatIndex].catId], this.contentCount, 1, 'CATEGORY', 'mDate', 'DESC', true).subscribe(cont => {
              this.relatedCategories$[1].categoryName = cont.result[0]?.categoryInfo.catName;
              this.relatedCategories$[1].categoryMedia = cont.result[0]?.medias;
            });
          }
        })
      })
    })
  }

  ngOnInit() { }

  public playGame(cId, gId) {
    this.router.navigate([`/play/${cId}/${gId}`], { queryParamsHandling: 'merge' });
  }

  public routeTo(catId, gameId) {
    this.router.navigate([`/`], { queryParamsHandling: 'merge', skipLocationChange: true }).then(() => {
      this.router.navigate([`/game/${catId}/${gameId}`], { queryParamsHandling: 'merge' });
    });
  }

}
